import { IconSVGProps } from '@clover-web-lib-sprout/common';
import cx from 'clsx';
import React, { forwardRef } from 'react';
import styles from './styles.module.scss';

export type IconButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  IconSVG?: React.FC<IconSVGProps>;
  icon?: React.ReactElement<React.SVGProps<SVGSVGElement>>;
  accessibleName: string;
  testId?: string;
  /** to change border radius from default, set true and pass through className */
  customBorderRadius?: boolean;
  /** to change padding or color via css, set true and pass through className */
  customStyle?: boolean;
  inFieldComponent?: boolean;
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, buttonRef) => {
  const {
    IconSVG,
    icon,
    accessibleName,
    className,
    testId,
    customBorderRadius,
    customStyle,
    inFieldComponent,
    ...buttonProps
  } = props;

  return (
    <button
      ref={buttonRef}
      type="button"
      className={cx(styles.icon, styles.iconButton, className, {
        [styles.disabled]: buttonProps.disabled,
        [styles.defaultBorderRadius]: !customBorderRadius,
        [styles.defaultStyle]: !customStyle,
        [styles.fieldStyle]: inFieldComponent,
      })}
      aria-label={accessibleName}
      data-testid={testId}
      {...buttonProps}
    >
      {IconSVG ? <IconSVG className={styles.buttonSvg} aria-hidden={true} focusable={false} role={'img'} /> : icon}
    </button>
  );
});

IconButton.displayName = 'IconButton';
